/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Implausible_Reps_CeilingInputs */

const en_us2_workout_live_implausible_reps_ceiling = /** @type {(inputs: Workout_Live_Implausible_Reps_CeilingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That's over 100 reps in a single set.`)
};

const pt_br2_workout_live_implausible_reps_ceiling = /** @type {(inputs: Workout_Live_Implausible_Reps_CeilingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`São mais de 100 repetições numa série só.`)
};

const es_419_workout_live_implausible_reps_ceiling = /** @type {(inputs: Workout_Live_Implausible_Reps_CeilingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son más de 100 repeticiones en una sola serie.`)
};

const pt_pt2_workout_live_implausible_reps_ceiling = /** @type {(inputs: Workout_Live_Implausible_Reps_CeilingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`São mais de 100 repetições numa só série.`)
};

const fr_fr2_workout_live_implausible_reps_ceiling = /** @type {(inputs: Workout_Live_Implausible_Reps_CeilingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ça fait plus de 100 répétitions en une seule série.`)
};

const de_de2_workout_live_implausible_reps_ceiling = /** @type {(inputs: Workout_Live_Implausible_Reps_CeilingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das sind über 100 Wiederholungen in einem Satz.`)
};

const it_it2_workout_live_implausible_reps_ceiling = /** @type {(inputs: Workout_Live_Implausible_Reps_CeilingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sono più di 100 ripetizioni in una sola serie.`)
};

/**
* | output |
* | --- |
* | "That's over 100 reps in a single set." |
*
* @param {Workout_Live_Implausible_Reps_CeilingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_implausible_reps_ceiling = /** @type {((inputs?: Workout_Live_Implausible_Reps_CeilingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Implausible_Reps_CeilingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_implausible_reps_ceiling(inputs)
	if (locale === "es-419") return es_419_workout_live_implausible_reps_ceiling(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_implausible_reps_ceiling(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_implausible_reps_ceiling(inputs)
	if (locale === "de-DE") return de_de2_workout_live_implausible_reps_ceiling(inputs)
	if (locale === "it-IT") return it_it2_workout_live_implausible_reps_ceiling(inputs)
	return en_us2_workout_live_implausible_reps_ceiling(inputs)
});
export { workout_live_implausible_reps_ceiling as "workout-live.implausible_reps_ceiling" }